import { render, staticRenderFns } from "./BCNetworkTone.vue?vue&type=template&id=22fb1372"
import script from "./BCNetworkTone.vue?vue&type=script&lang=js"
export * from "./BCNetworkTone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports